import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import SEOHead from "@/components/SEOHead";
import { HomeStructuredData } from "@/components/StructuredData";
import HeroSection from "@/components/home/HeroSection";
import ServicesSection from "@/components/home/ServicesSection";
import WhyUsSection from "@/components/home/WhyUsSection";
import ReviewsSection from "@/components/home/ReviewsSection";
import CTASection from "@/components/home/CTASection";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  const [testimonials, setTestimonials] = useState([]);

  const fetchTestimonials = useCallback(() => {
    axios.get(`${API}/testimonials`).then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    fetchTestimonials();
  }, [fetchTestimonials]);

  return (
    <main data-testid="home-page">
      <SEOHead
        title="Noleggio Con Conducente Premium"
        description="Transfer Avellino: servizio NCC premium ad Avellino e Campania. Transfer aeroportuali, stazioni, eventi, business travel e tour personalizzati. Autisti professionisti, veicoli di lusso, disponibilità H24. Chiama +39 378 4035054."
        path="/"
      />
      <HomeStructuredData />
      <HeroSection />
      <ServicesSection />
      <WhyUsSection />
      <ReviewsSection testimonials={testimonials} />
      <CTASection />
    </main>
  );
}
